import React, { useEffect, useState } from "react";

// Components
import FullButton from "../Buttons/FullButton";
// Assets
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";
import { BtnWrapper, DotsWrapper, GreyDiv, HeaderP, HeaderTitle, ImageWrapper, Img, LeftSide, QuotesWrapper, QuoteWrapper, RightSide, Wrapper } from "../../style/header.styles";

export default function Header() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    setIsLoggedIn(!!user);
  }, []);

  return (
    <Wrapper id="home" className="container flexSpaceCenter lightBg">
      <LeftSide className="flexCenter">
        <div>
          <HeaderTitle className="darkGreenColor">
            Real Projects, Real Impact.
          </HeaderTitle>
          <HeaderP className="font20 regular">
            We bring together top university minds and forward-thinking
            businesses to co-create solutions for real-world challenges.
          </HeaderP>
          <HeaderP className="font20 regular">
            Talents gain invaluable experience, while companies unlock
            innovative solutions and fresh ideas. Empowering talents, driving
            business success!
          </HeaderP>
          {!isLoggedIn ? (
            <BtnWrapper>
              <FullButton
                title="Get Started"
                action={() => (window.location.href = "/register")}
              />
            </BtnWrapper>
          ) : (
            ""
          )}
        </div>
      </LeftSide>
      <RightSide>
        <ImageWrapper>
          <Img
            className="radius8"
            src={`${process.env.PUBLIC_URL}/heroimg2.jpg`}
            width={500}
            height={650}
            alt="office"
            style={{ zIndex: 9 }}
          />
          <QuoteWrapper className="flexCenter greyTransparentBg radius8">
            <QuotesWrapper>
              <QuotesIcon />
            </QuotesWrapper>
            <div>
              <p className="font15 darkGreenColor">
                <em>Opportunities don't happen. You create them."</em>
              </p>
              <p
                className="font13 darkGreenColor textRight"
                style={{ marginTop: "10px" }}
              >
                Chris Grosser
              </p>
            </div>
          </QuoteWrapper>
          <DotsWrapper>
            <Dots />
          </DotsWrapper>
        </ImageWrapper>
        <GreyDiv className="lightBg"></GreyDiv>
      </RightSide>
    </Wrapper>
  );
}
